import apiPlatform from "./apiPlatform";
import {STORAGE_TIRE_DOCUMENT_TYPE_NAME} from "./utils/documentsTypeName";
import {TAB_COMPONENTS, TAB_MODULES} from "./views/UserViews/TecRmi/MainView";

const routesUser = {
  home: '/',
  changelog: '/historia-zmian',
  login: '/logowanie',
  resetPassword: '/resetuj-haslo',
  resetPasswordConfirm: id => `/resetuj-haslo/${id}`,
  register: '/rejestracja',
  logout: '/wyloguj',
  supplement: '/uzupelnij-dane',

  betis: {
    main: '/pomoc-betis',
  },

  repairOrdersMain: '/warsztat',
  repairOrders: '/warsztat/zlecenie',
  repairOrderNew: '/warsztat/zlecenie/nowe',
  repairOrder: (id, tab = 'zadania') => '/warsztat/zlecenie/' + id + '/' + tab,
  repairOrderPreview: (id, download = false) => `/v/zlecenie/${id}/podglad.pdf${download ? '?pobierz=1' : ''}`,
  repairOrderSpecification: (id, download = false) => `/v/zlecenie/${id}/specyfikacja.pdf${download ? '?pobierz=1' : ''}`,
  repairOrderElectronicCardLink: (uniqKey) => `/panel-klienta/${uniqKey}`,
  repairOrderElectronicCardDocumentTypeLink: (uniqKey, documentType, print = false) => `/panel-klienta/${uniqKey}/${documentType}${print ? `?drukuj=1` : ''}`,
  repairOrderElectronicCardDocumentTypePdfDownload: (uniqKey, documentType, print = false) => `/panel-klienta/${uniqKey}/${documentType}.pdf?pobierz=1`,

  quotations: {
    list: '/warsztat/wyceny',
    'new': `/warsztat/wyceny/nowa`,
    edit: (id) => `/warsztat/wyceny/edycja/${id}`,
    view: (id) => `/warsztat/wyceny/podglad/${id}`,
    documentDownload: (id) => `/v/wycena/${id}.pdf?pobierz=1`,
    documentPreview: (id) => `/v/wycena/${id}.pdf`,
  },

  repairOrderJobs: '/zadania',


  cashBoxDocument: {
    list: '/kasa',
    'new': (type) => `/kasa/nowy/${type}`,
    edit: (id) => `/kasa/edycja/${id}`,
    view: (id) => `/kasa/podglad/${id}`,
    documentPreview: (id) => '/v/kasa/' + id + '/podglad.pdf',
    documentDownload: (id) => '/v/kasa/' + id + '/podglad.pdf?pobierz=1',
  },

  office: {
    main: '/biuro',

    saleDocument: {
      list: '/biuro/sprzedaz',
      'new': (type, repairOrders = [], receiptFiscal = null, saleDocumentToCorrection = null, correctionType = null, proFormaDocument = null, storageDocuments = []) => {
        let path = `/biuro/sprzedaz/nowa/${type}`;
        if(repairOrders.length > 0){
          path += '?zlecenia=' + repairOrders.join(',')
        }
        if(storageDocuments.length > 0){
          path += '?przechowalnia=' + storageDocuments.join(',')
        }
        if(receiptFiscal){
          path += '?paragon=' + receiptFiscal
        }
        if(saleDocumentToCorrection){
          path += '?koryguj=' + saleDocumentToCorrection + '&type=' + correctionType
        }
        if(proFormaDocument){
          path += '?proForma=' + proFormaDocument
        }

        return path;
      },
      edit: (id) => `/biuro/sprzedaz/edycja/${id}`,
      view: (id) => `/biuro/sprzedaz/podglad/${id}`,
      documentPreview: (id, duplicateDate = null) => '/v/biuro/sprzedaz/' + id + '/podglad.pdf?' + (duplicateDate ? `duplikat=${duplicateDate}` : ''),
      documentDownload: (id) => '/v/biuro/sprzedaz/' + id + '/podglad.pdf?pobierz=1',
      documentsPrint: (ids) => `/v/biuro/sprzedaz/dokumenty.pdf?ids=${ids}`,
      documentsList: (ids) => `/v/biuro/sprzedaz/zestawienie-dokumentow.pdf?ids=${ids}`,
      itemsPreview: (ids) => `/v/biuro/sprzedaz/pozycje.pdf?ids=${ids}`,
      demandForPayment: (ids) => `/v/biuro/sprzedaz/wezwanie-do-zaplaty.pdf?ids=${ids}`,
    },

    proFormaDocument: {
      list: '/biuro/pro-forma',
      'new': (repairOrders = []) => {
        let path = `/biuro/pro-forma/nowa`;
        const params = [];

        if(repairOrders.length > 0){
          params.push('zlecenia=' + repairOrders.join(','))
        }

        if(params.length > 0){
          path += '?' + params.join('&')
        }

        return path;
      },
      edit: (id) => `/biuro/pro-forma/edycja/${id}`,
      view: (id) => `/biuro/pro-forma/podglad/${id}`,
      documentPreview: (id) => '/v/biuro/pro-forma/' + id + '/podglad.pdf',
      documentDownload: (id) => '/v/biuro/pro-forma/' + id + '/podglad.pdf?pobierz=1',
    },

    clientPayment: {
      list: '/platnosci-klientow',
    },
  },

  timetable: '/terminarz',

  clients: '/klienci',
  clientNew: '/klienci/nowy',
  client: (id) => '/klienci/' + id,

  vehicles: '/pojazdy',
  vehicleNew: '/pojazdy/nowy',
  vehicle: (id, tab = 'ogolne') => '/pojazdy/' + id + '/' + tab,

  reports: {
    main: '/raporty',
    level0: (name) => '/raporty/' + name,
    report: (name, subName) => '/raporty/' + name + '/' + subName,
  },

  products: {
    list: '/towary',
    productNew: '/towary/nowy',
    product: id => '/towary/' + id,
  },

  storageDocument: {
    list: '/przechowalnia',
    'new': (type = STORAGE_TIRE_DOCUMENT_TYPE_NAME) => `/przechowalnia/utworz/${type}`,
    edit: (id) => `/przechowalnia/${id}`,
    view: (id) => `/przechowalnia/podglad/${id}`,
    documentPrint: (id) => '/v/przechowalnia/' + id + '/podglad.pdf?print=1',
    documentPreview: (id) => '/v/przechowalnia/' + id + '/podglad.pdf',
    labels: (id) => '/v/przechowalnia/' + id + '/etykiety.pdf',
  },

  warehouse: {
    incomeProducts: '/magazyn/przyjecie-od-hurtowni',
  },

  warehouseDocument: {
    main: '/magazyn',
    list: '/magazyn/dokumenty',
    'new': (type, repairOrders = []) => {
      let path = `/magazyn/dokumenty/nowy/${type}`;
      if(repairOrders.length > 0){
        path += '?zlecenia=' + repairOrders.join(',')
      }

      return path;
    },
    edit: id => `/magazyn/dokumenty/edycja/${id}`,
    view: id => `/magazyn/dokumenty/podglad/${id}`,
    documentPreview: (id) => '/v/magazyn/' + id + '/podglad.pdf',
    documentDownload: (id) => '/v/magazyn/' + id + '/podglad.pdf?pobierz=1',

    reservation: {
      list: '/magazyn/rezerwacje',
    },

    itemsPreview: (ids) => `/v/magazyn/pozycje.pdf?ids=${ids}`,
    documentsPreview: (ids) => `/v/magazyn/dokumenty.pdf?ids=${ids}`,
  },

  warehouseDocumentInventory: {
    list: '/magazyn/inwentaryzacja',
    edit: (id = ':id') => `/magazyn/inwentaryzacja/${id}/edytuj`,
    view: (id = ':id') => `/magazyn/inwentaryzacja/${id}/podglad`,
    documentPreview: (id) => '/v/inwentaryzacja/' + id + '/podglad.pdf',
    documentDownload: (id) => '/v/inwentaryzacja/' + id + '/podglad.pdf?pobierz=1',
  },

  smsMessages: {
    list: '/sms/lista',
  },

  clientMails: {
    list: '/email/lista',
  },

  reminders: {
    list: '/planowane-przypomnienia',
  },

  dataLeaks: '/naruszenie-danych',
  account: '/moje-konto',
  choosePlan: '/wybierz-plan',
  choosePaymentMethod: (period = null, settings = []) => {
    let params = [];
    if(period){
      params.push(`okres=${period}`)
    }
    if(settings.length > 0){
      params.push(`settings=${settings.join(',')}`)
    }

    params = params.join('&')
    return '/metoda-platnosci' + (params ? `?${params}` : '')
  },
  pay: '/oplac',
  discountCode: '/kod-rabatowy',
  paymentConfirmation: '/potwierdzenie-platnosci',
  workshopPlanTransactions: '/historia-transakcji',

  jpk: '/jpk',
  jpkFa: (date) => apiPlatform.jpk.jpkFa(date),
  jpkVat7: (date) => apiPlatform.jpk.jpkVat7(date),
  jpkMag: (date) => apiPlatform.jpk.jpkMag(date),

  settings: {
    main: '/ustawienia',
    general: {
      main: '/ustawienia/ogolne',
      documents: '/ustawienia/ogolne/dokumenty',
      electronicRepairOrderCard: '/ustawienia/ogolne/elektroniczna-karta-zlecenia',
      cashBoxes: {
        list: '/ustawienia/ogolne/kasy',
        'new': '/ustawienia/ogolne/kasy/dodaj',
        edit: (id = ':id') => `/ustawienia/ogolne/kasy/${id}`,
      },
      primary: '/ustawienia/ogolne/podstawowe',
      profile: '/ustawienia/ogolne/dane-firmy',
      series: {
        list: '/ustawienia/ogolne/numeracja-dokumentow',
        serie: (id) => '/ustawienia/ogolne/numeracja-dokumentow/' + id,
      },
      emailTemplates: '/ustawienia/ogolne/szablony-email',
    },
    timetable: {
      main: '/ustawienia/terminarz',
      primary: '/ustawienia/terminarz/podstawowe',
      calendars: {
        list: '/ustawienia/terminarz/kalendarze-dodatkowe',
        calendarNew: '/ustawienia/terminarz/kalendarze-dodatkowe/nowy',
        calendar: id => `/ustawienia/terminarz/kalendarze-dodatkowe/${id}`,
      },
    },
    workshop: {
      main: '/ustawienia/warsztat',
      primary: '/ustawienia/warsztat/podstawowe',
      advanced: '/ustawienia/warsztat/zaawansowane',
      repairOrders: '/ustawienia/warsztat/zlecenia',
      quotations: '/ustawienia/warsztat/wyceny',
      vehicle: '/ustawienia/warsztat/pojazdy',
      timetable: '/ustawienia/warsztat/terminarz',
      workingHours: '/ustawienia/warsztat/godziny-pracy',
      cardControlTemplates: {
        list: '/ustawienia/warsztat/listy-kontrolne',
        cardControlTemplateNew: '/ustawienia/warsztat/listy-kontrolne/nowa',
        cardControlTemplate: (id) => '/ustawienia/warsztat/listy-kontrolne/' + id,
      },
      repairOrderStatuses: {
        list: '/ustawienia/warsztat/statusy-zlecen',
        repairOrderStatusNew: '/ustawienia/warsztat/statusy-zlecen/nowy',
        repairOrderStatus: (id) => '/ustawienia/warsztat/statusy-zlecen/' + id,
      },
      workplaces: {
        list: '/ustawienia/warsztat/stanowiska-pracy',
        workplaceNew: '/ustawienia/warsztat/stanowiska-pracy/nowe',
        workplace: (id) => '/ustawienia/warsztat/stanowiska-pracy/' + id,
      },
      workers: {
        list: '/ustawienia/warsztat/pracownicy',
        workerNew: '/ustawienia/warsztat/pracownicy/nowy',
        worker: (id) => '/ustawienia/warsztat/pracownicy/' + id,
      },
      repairOrderKinds: {
        list: '/ustawienia/warsztat/rodzaje-zlecen',
        repairOrderKindNew: '/ustawienia/warsztat/rodzaje-zlecen/nowy',
        repairOrderKind: id => '/ustawienia/warsztat/rodzaje-zlecen/' + id,
      },
      jobTemplates: {
        list: '/ustawienia/warsztat/szablony-zadan',
        jobTemplateNew: '/ustawienia/warsztat/szablony-zadan/nowy',
        jobTemplate: id => '/ustawienia/warsztat/szablony-zadan/' + id,
      },
    },
    warehouse: {
      main: '/ustawienia/magazyn',
      product: '/ustawienia/magazyn/towary',
      manufacturers: {
        list: '/ustawienia/magazyn/producenci',
        manufacturerNew: '/ustawienia/magazyn/producenci/nowy',
        manufacturer: id => '/ustawienia/magazyn/producenci/' + id,
      },
      workshopProductPriceGroups: {
        list: '/ustawienia/magazyn/grupy-cenowe',
        workshopProductPriceGroupNew: '/ustawienia/magazyn/grupy-cenowe/nowa',
        workshopProductPriceGroup: id => '/ustawienia/magazyn/grupy-cenowe/' + id,
      },
    },
    storage: {
      main: '/ustawienia/przechowalnia',
      primary: '/ustawienia/przechowalnia/podstawowe',
      taskTemplates: {
        list: '/ustawienia/przechowalnia/szablony-zadan',
      },
    },
    integrations: '/ustawienia/integracje',
    export: '/ustawienia/eksport-danych',
    import: {
      main: '/ustawienia/import-danych',
      other: '/ustawienia/import-danych/inne',
    },
    suppliers: {
      list: '/ustawienia/integracje/dystrybutorzy',
      supplier: id => '/ustawienia/integracje/dystrybutorzy/' + id,
    },
  },
  tecRmi: {
    main:`/dane-naprawcze`,
    ident: (ident = ':ident') => `/dane-naprawcze/${ident}`,
    tab: (typeId = ':typeId', tab = ':tab', params = null) => `/dane-naprawcze/${typeId}/${tab}${params ? `/${params}` : ''}`,
    tabModule: (typeId = ':typeId', module = ':module', params = '') => `/dane-naprawcze/${typeId}/${TAB_MODULES}/${module}/${params}`,
    tabComponentMainGroup: (typeId = ':typeId', mainGroupId = ':mainGroupId') => `/dane-naprawcze/${typeId}/${TAB_COMPONENTS}/${mainGroupId}`,
    tabComponentSubGroup: (typeId = ':typeId', mainGroupId = ':mainGroupId', subgroupId = ':subgroupId', module = ':module', params = ':params') => `/dane-naprawcze/${typeId}/${TAB_COMPONENTS}/${mainGroupId}/${subgroupId}${module ? `/${module}` : ''}${params ? `/${params}` : ''}`,
  },

  tpayRegistration: '/tpay',

  _print: {
    cardControl: (id) => '/v/lista-kontrolna/' + id + `/drukuj.pdf?locale=${localStorage.getItem('i18nextLng')}`,
  },
  csvExamples: {
    standard: `/import/csv-examples/przyklad-przyjecie-wewnetrzne.csv`,
    cars: `/import/csv-examples/przyklad-przyjecie-wewnetrzne-pojazdow.csv`,
    parts: `/import/csv-examples/przyklad-przyjecie-wewnetrzne-towarow.csv`,
    clients: `/import/csv-examples/przyklad-przyjecie-wewnetrzne-klientow.csv`,
    jobTemplates: `/import/csv-examples/przyklad-przyjecie-wewnetrzne-szablonow-zadan.csv`,
  },
};

export default routesUser;